export const callError = {
  title: "エラーが発生しました",
  sendMessage: "メッセージを送る",
  autoClose: (args: { count: string | number }) =>
    `${args.count}秒後に自動で閉じます`,
  messages: {
    connectionFailed:
      "接続に失敗しました。しばらくしてから再度お試しください。",
    billingFailed: "決済処理中にエラーが発生しました。",
    fetchFailed:
      "情報の取得に失敗しました。しばらくしてから再度お試しください。",
    videoTimeout:
      "相手の映像を再生できませんでした。時間をおいて再度お試しください。",
    videoTimeoutNote: "ポイントは消費されていません。",
    videoFrozen: "相手の映像が途切れました。時間をおいて再度お試しください。",
    channelEnded: "この配信はすでに終了しています。",
    broadcasterLeft: "お相手が配信を終了しました。",
    broadcasterLeftCall: "お相手が通話を終了しました。",
  },
} as const;
